import { DispatchAction, RegisterActionListener } from "../state/State.js";
import { TimerActions } from "../state/FrameworkReducer.js";
import { GameActions } from "../state/GameReducer.js";
import { ConnectedHTMLElement } from "./ConnectedHtmlElement.js";

/**
 * @name GameTimer
 * @class GameTimer
 * @extends {HTMLElement}
 */
export class GameTimer extends ConnectedHTMLElement {
  static observedAttributes = ["player"];
  timerSeconds = 0;
  timerRunning = false;
  interval;
  constructor() {
    super();
    this.render();
    this.startTimer();
    RegisterActionListener(TimerActions.startTimer, () => {
      this.startTimer();
    });
    RegisterActionListener(GameActions.end, () => {
      this.stopTimer();
    });
    RegisterActionListener(TimerActions.stopTimer, () => {
      this.stopTimer();
    });
    RegisterActionListener(TimerActions.resetTimer, () => {
      this.resetTimer();
    });
  }

  /**
   * @param {SwucState} newState
   * @param {SwucState} oldState
   */
  stateUpdated(newState, oldState) {
    if (
      (oldState.currentGame === undefined &&
        newState.currentGame !== undefined) ||
      (oldState.currentGame?.ended === true &&
        newState.currentGame?.ended === true)
    ) {
      this.render();
    }
  }

  resetTimer() {
    this.timerSeconds = 0;
    this.render();
  }

  startTimer() {
    if (this.timerRunning) return;
    this.timerRunning = true;
    this.render();
    this.interval = setInterval(() => {
      this.timerSeconds++;
      this.renderTimer();
    }, 1000);
  }

  stopTimer() {
    clearInterval(this.interval);
    this.timerRunning = false;
    this.render();
  }

  addLeadingZero(value) {
    return value < 10 ? `0${value}` : value;
  }

  getTime() {
    const minutes = Math.floor(this.timerSeconds / 60);
    const seconds = this.timerSeconds % 60;
    if (minutes > 60) {
      return `${this.addLeadingZero(Math.floor(minutes / 60))}:${this.addLeadingZero(minutes % 60)}:${this.addLeadingZero(seconds)}`;
    }
    return `${this.addLeadingZero(minutes)}:${this.addLeadingZero(seconds)}`;
  }
  renderTimer() {
    const timeEl = this.querySelector("#time");
    if (timeEl) {
      timeEl.innerText = this.getTime();
    }
  }

  registerEvents() {
    const start = this.querySelector("#start");
    const stop = this.querySelector("#stop");
    const reset = this.querySelector("#reset");

    start &&
      start.addEventListener("click", () => {
        DispatchAction(TimerActions.startTimer);
      });
    stop &&
      stop.addEventListener("click", () => {
        DispatchAction(TimerActions.stopTimer);
      });
    reset &&
      reset.addEventListener("click", () => {
        DispatchAction(TimerActions.resetTimer);
      });
  }

  render() {
    if (this.state.currentGame === undefined || this.state.currentGame?.ended) {
      clearInterval(this.interval);
      this.timerRunning = false;
      this.innerHTML = "";
      return;
    }
    if (this.timerRunning) {
      this.innerHTML = `
        <div class="flex items-center justify-end mt-3">
          <button id="stop" class="border-0 cursor-pointer bg-transparent">
            <img src="/assets/icons/timer.svg" alt="Start timer" width="24" height="24" class="bg-black p-1 rounded-full" />
          </button>
          <span id="time">${this.getTime()}</span>
        </div>
      `;
    } else {
      this.innerHTML = `
        <div class="flex items-center justify-end mt-3">
          <button id="reset" class="border-0 cursor-pointer bg-transparent">
            <img src="/assets/icons/reset.svg" alt="Reset timer" width="24" height="24" class="bg-black p-1 rounded-full" />
          </button>
          <button id="start" class="border-0 cursor-pointer bg-transparent">
            <img src="/assets/icons/timer-off.svg" alt="Start timer" width="24" height="24" class="bg-black p-1 rounded-full" />
          </button>
          <span>${this.getTime()}</span>
        </div>
      `;
    }
    this.registerEvents();
  }
  connectedCallback() {
    this.render();
  }
}
